if (!window.homeQuickBuyInitialized) {
  window.homeQuickBuyInitialized = true;

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-quick-buy-open]');
    if (openButton) {
      const dialog = document.getElementById(openButton.dataset.quickBuyOpen);
      if (dialog instanceof HTMLDialogElement) dialog.showModal();
      return;
    }

    const closeButton = event.target.closest('[data-quick-buy-close]');
    if (closeButton) closeButton.closest('dialog')?.close();
  });

  document.addEventListener('click', (event) => {
    if (event.target instanceof HTMLDialogElement && event.target.classList.contains('home-quick-buy')) {
      event.target.close();
    }
  });

  document.addEventListener('change', (event) => {
    const input = event.target.closest('.home-quick-buy__variant input');
    if (!input) return;

    const dialog = input.closest('.home-quick-buy');
    if (!dialog) return;

    const title = dialog.querySelector('[data-selected-variant]');
    const price = dialog.querySelector('[data-modal-price]');
    const comparePrice = dialog.querySelector('[data-modal-compare-price]');
    const discount = dialog.querySelector('[data-modal-discount]');

    if (title) title.textContent = input.dataset.title || '';
    if (price) price.textContent = input.dataset.price || '';
    if (comparePrice) {
      comparePrice.textContent = input.dataset.comparePrice || '';
      comparePrice.hidden = !input.dataset.comparePrice;
    }
    if (discount) discount.textContent = input.dataset.discount || '';
  });
}
